module.exports = __webpack_public_path__ + "img/alaskaNationGuard.8a0795dc.jpeg";